// @ts-nocheck
import * as Types from '../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import * as ApolloReactCommon from 'src/apolloHooks';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type SaveLienWaiverDocumentMutationVariables = Types.Exact<{
  input: Types.SaveDocumentInput;
}>;


export type SaveLienWaiverDocumentMutation = { __typename?: 'Mutation', saveDocuments: { __typename?: 'SaveDocumentsResult', documents: Array<{ __typename?: 'Document', id: string, name: string }> } };


export const SaveLienWaiverDocumentDocument = gql`
    mutation SaveLienWaiverDocument($input: SaveDocumentInput!) {
  saveDocuments(input: {documents: [$input]}) {
    documents {
      id
      name
    }
  }
}
    `;

/**
 * __useSaveLienWaiverDocumentMutation__
 *
 * To run a mutation, you first call `useSaveLienWaiverDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveLienWaiverDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveLienWaiverDocumentMutation, { data, loading, error }] = useSaveLienWaiverDocumentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveLienWaiverDocumentMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SaveLienWaiverDocumentMutation, SaveLienWaiverDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SaveLienWaiverDocumentMutation, SaveLienWaiverDocumentMutationVariables>(SaveLienWaiverDocumentDocument, options);
      }
export type SaveLienWaiverDocumentMutationHookResult = ReturnType<typeof useSaveLienWaiverDocumentMutation>;
export type SaveLienWaiverDocumentMutationResult = ApolloReactCommon.MutationResult<SaveLienWaiverDocumentMutation>;